<template>
  <base-stack class="user-emails" :spacing="6">
    <strong class="disclaimer">Available from 2025-05-27, engagement data from 2025-06-06</strong>
    <base-stack as="ul" v-if="user.emails && user.emails.length">
      <li v-for="email in user.emails" :key="email.id">
        <app-email-transaction-cell :email="email"></app-email-transaction-cell>
      </li>
    </base-stack>
    <p v-else>No emails sent to this user.</p>
  </base-stack>
</template>

<script lang="ts">
import AppEmailTransactionCell from '@/components/EmailTransactionCell.vue';
import { User } from '@/types/api';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: { AppEmailTransactionCell },
})
export default class UserEmails extends Vue {
  @Prop({ type: Object, required: true }) public user!: User;
}
</script>

<style lang="scss" scoped>
.user-emails {
  padding: 1rem 0;

  .disclaimer {
    color: $color-theme-red;
    font-weight: 600;
    border: 1px solid $color-theme-red;
    padding: 0.5rem 1rem;
  }

  h3 {
    color: $color-theme-red;
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0 0 1rem 0;
  }
}
</style>
